<!-- <div *transloco="let t;" class="p-5 sm:p-10"> -->
    <!-- <div class="title flex flex-col bg-k-darker rounded-lg p-5 mb-4">
        <div class="gradient-text font-nikkyou text-[16px] sm:text-[30px] font-normal uppercase">
            <span>{{t('primusBazaar.primusBazaar')}}</span>
        </div>
        <span class="text-[12px] sm:text-[16px]">{{t('primusBazaar.subTitle')}}</span>
        <div class="flex mt-1 text-[12px] sm:text-[16px]">
            <img class="mr-2 w-[20px] h-auto sm:w-[24px]" src="/assets/img/Icon/Label-NFT-Lock.png">
            <span class="font-bold">BOUNDED NFT:&nbsp;</span>
            <span>{{t('primusBazaar.boundedNFTdesc')}}</span>
        </div>
    </div> -->
    <div class="flex flex-wrap gap-4 place-content-center sm:place-content-start">
        <k-company-item-card *ngFor="let item of companyItemsData;" [data]="item"
            (onCardClick)="onCardClick($event)"></k-company-item-card>
    </div>

<!-- </div> -->